import { render, staticRenderFns } from "./RAlert.vue?vue&type=template&id=5e58aff7&scoped=true"
import script from "./RAlert.vue?vue&type=script&lang=js"
export * from "./RAlert.vue?vue&type=script&lang=js"
import style0 from "./RAlert.vue?vue&type=style&index=0&id=5e58aff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58aff7",
  null
  
)

export default component.exports